<app-standard-data-table (gridRequested)="gridRequested($event)" [source]="commandExecutionHistorys" [sorts]="[{ prop: 'timestamp', dir: 'desc' }]" [columns]="columns$ | async" [noRecordsMessage]="noRecords"></app-standard-data-table>

<ng-template #resultTemplate let-row="row">
    <app-command-execution-result [resultStatus]="row?.resultStatus"> </app-command-execution-result>
</ng-template>

<ng-template #timestampTemplate let-row="row">
    {{ row?.timestamp | date: 'yyyy-MM-dd HH:mm' : 'UTC' }}
</ng-template>

<ng-template #parameterValuesTemplate let-row="row">
    <div class="text-truncate" [ngbTooltip]="parameters">
        {{ row?.parameterValues | beautifyJson }}
        <ng-template #parameters>
            <div innerHTML="{{ row?.parameterValues | beautifyJson: true }}"></div>
        </ng-template>
    </div>
</ng-template>

<ng-template #responseTemplate let-row="row">
    @if (row?.result == 'null') {
        <app-command-execution-result [resultStatus]="row?.resultStatus"> </app-command-execution-result>
    }
    @if (row?.result != 'null') {
        {{ row?.result | beautifyJson }}
    }
</ng-template>

<ng-template #noRecords>
    <div class="vertical-centering default-icon-color">
        <i class="fas fa-info-circle fa-7x"></i>
        <div class="no-records-message">{{ 'executionHistory.noDataFound' | translation | async }}</div>
        <div class="no-records-message-detail">{{ 'executionHistory.noDataFoundDetail' | translation | async }}</div>
    </div>
</ng-template>
